import classNames from 'classnames'

import Button from '../Button'

import * as styles from './White.module.css'

function White({ className, isActive, isGrey, ...restProps }) {
  const buttonClassName = classNames(
    styles.white,
    { [styles.basic]: !isGrey },
    { [styles.grey]: isGrey },
    { [styles.active]: isActive },
    className
  )

  return (
    <Button
      {...restProps}
      shadowed
      className={buttonClassName}
      isActive={isActive}
    />
  )
}

export default White
